var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    {
      ref: "popover",
      staticClass: "time-tracking__color-picker q-pa-sm",
      on: {
        show: function($event) {
          _vm.$emit("show", $event)
        },
        hide: function($event) {
          _vm.$emit("hide", $event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "row justify-between items-center gutter-sm" },
        _vm._l(_vm.colors, function(color, index) {
          return _c("div", { key: index, staticClass: "col-auto" }, [
            _c("div", {
              staticClass: "time-tracking__color-picker__color circle",
              style: { "background-color": color },
              on: {
                click: function($event) {
                  _vm.handleSelectColor(color)
                }
              }
            })
          ])
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }